import { Me } from "../types/api-schema";

import fetchIfAuthorized from "./fetchIfAuthorized";

export default function fetchMe(
  url: string,
  init?: RequestInit,
): Promise<Me | null> {
  return fetchIfAuthorized<Me>(url, init);
}
